export enum FinancingProcessFilterCriteria {
  CURRENT_PAGE = 'CURRENT_PAGE',
  SEARCH_TEXT = 'SEARCH_TEXT',
  ACTIVE_TAB = 'ACTIVE_TAB',
  ACTIVE_PILL = 'ACTIVE_PILL'
}
